import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/route-guards'
import GeneralSettingsPage from '@/components/general-settings.tsx'

export const Route = createFileRoute('/_authenticated/settings')({
  beforeLoad: requireAuth,
  component: GeneralSettingsPage,
})